var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "yxtbiz-ote-ai-textarea",
      class: {
        "yxtbiz-ote-ai-textarea--focus": _vm.focus,
        "yxtbiz-ote-ai-textarea--disabled": _vm.disabled,
        "yxtbiz-ote-ai-textarea--sub": _vm.showSub,
      },
      attrs: { id: _vm.id },
      on: { click: _vm.startInput },
    },
    [
      _vm.$slots.header
        ? _c(
            "div",
            {
              staticClass: "yxtbiz-ote-ai-textarea__header flex flex-mid mb12",
            },
            [
              _c(
                "div",
                { staticClass: "flex-g-1 shrink1 overflow-hiden" },
                [_vm._t("header")],
                2
              ),
            ]
          )
        : _vm.$slots.contentSub
        ? _c(
            "div",
            { staticClass: "yxtbiz-ote-ai-textarea__header flex flex-mid" },
            [
              _c("div", { staticClass: "flex-g-1 shrink1 overflow-hiden" }, [
                _c(
                  "div",
                  { staticClass: "yxtbiz-ote-ai-textarea__sub-input" },
                  [
                    _c(
                      "YxtbizOteAiTextarea",
                      {
                        ref: "txtAsk",
                        attrs: {
                          maxlength: _vm.maxlength,
                          disabled: _vm.disabled || _vm.subDisabled,
                          btnTip: _vm.btnTip,
                          subTip: _vm.subTip,
                          canBlur: _vm.canBlur,
                          canSave: _vm.canSave,
                          btnText: _vm.btnText,
                          placeholder: _vm.placeholder,
                        },
                        on: {
                          save: _vm.saveSub,
                          focus: function ($event) {
                            return _vm.showSubInput(true)
                          },
                          blur: function ($event) {
                            return _vm.showSubInput(false)
                          },
                        },
                        model: {
                          value: _vm.txt,
                          callback: function ($$v) {
                            _vm.txt = $$v
                          },
                          expression: "txt",
                        },
                      },
                      [
                        _vm._t("subinfo", null, { slot: "subinfo" }),
                        _vm._t("options", null, { slot: "options" }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
              _vm.$slots.contentSub
                ? _c(
                    "div",
                    { staticClass: "flex flex-mid shrink0 z-index-20" },
                    [_vm._t("contentSub")],
                    2
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm.$slots.content
        ? _c(
            "div",
            { staticClass: "yxtbiz-ote-ai-textarea__content" },
            [
              _c(
                "yxt-scrollbar",
                { attrs: { "fit-height": true } },
                [_vm._t("content")],
                2
              ),
            ],
            1
          )
        : [
            _c(
              "div",
              { staticClass: "yxtbiz-ote-ai-textarea__txt" },
              [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.txt,
                      expression: "txt",
                    },
                  ],
                  ref: "inputRef",
                  attrs: {
                    maxlength: _vm.maxlength,
                    placeholder: _vm.placeholder,
                  },
                  domProps: { value: _vm.txt },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.txt = $event.target.value
                    },
                  },
                }),
                _c(
                  "span",
                  {
                    staticClass: "yxtbiz-ote-ai-textarea__txt-fake ellipsis",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "ellipsis mr12 hand",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.startInput.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.txt || _vm.subTip))]
                    ),
                    !_vm.disabled
                      ? _c(
                          "div",
                          {
                            staticClass: "yxtbiz-ote-ai-icon hand",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.startInput.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("yxt-svg", {
                              attrs: {
                                width: "16px",
                                height: "16px",
                                "icon-class": "edit",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._t("sub"),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "yxtbiz-ote-ai-textarea__subinfo" },
              [_vm._t("subinfo")],
              2
            ),
            _c(
              "div",
              {
                staticClass: "yxtbiz-ote-ai-textarea__btns",
                class: {
                  "yxtbiz-ote-ai-textarea__btns--text": _vm.btnText,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "yxtbiz-ote-ai-textarea__options" },
                  [_vm._t("options")],
                  2
                ),
                _c("div", [
                  _c("span", { staticClass: "color-gray-7" }, [
                    _vm._v(_vm._s(_vm.txt.length)),
                  ]),
                  _c("span", { staticClass: "color-gray-6" }, [
                    _vm._v("/" + _vm._s(_vm.maxlength)),
                  ]),
                ]),
                (_vm.txt && _vm.txt.trim()) || _vm.canSave
                  ? [
                      _c(
                        "div",
                        { staticClass: "yxtbiz-ote-ai-icon hand" },
                        [
                          _c("yxt-svg", {
                            staticClass: "hand",
                            attrs: {
                              "remote-url": _vm.SvgMediaNewUrl,
                              width: "16px",
                              height: "16px",
                              "icon-class": "ai-clean-cc",
                            },
                            nativeOn: {
                              click: function ($event) {
                                _vm.txt = ""
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      !_vm.btnText && !_vm.hideBtn
                        ? _c(
                            "yxt-tooltip",
                            {
                              attrs: {
                                disabled: !_vm.btnTip || !_vm.focus,
                                content: _vm.btnTip,
                                placement: "top",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "yxtbiz-ote-ai-textarea__btn-pub",
                                  on: { click: _vm.save },
                                },
                                [
                                  _c("yxt-svg", {
                                    staticClass: "hand",
                                    attrs: {
                                      "remote-url": _vm.SvgMediaNewUrl,
                                      width: "16px",
                                      height: "16px",
                                      "icon-class": "ai-publish",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _vm.btnText &&
                !_vm.hideBtn &&
                ((_vm.txt && _vm.txt.trim()) || _vm.canSave)
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "yxtbiz-ai-create-txt-btn",
                          on: { click: _vm.save },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(_vm.btnText) + "\n        "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ],
      _vm.$slots.contentBottomSub
        ? _c(
            "div",
            { staticClass: "yxtbiz-ote-ai-textarea__bottom-sub" },
            [_vm._t("contentBottomSub")],
            2
          )
        : _vm._e(),
      _vm.$slots.contentBottom
        ? _c(
            "div",
            { staticClass: "yxtbiz-ote-ai-textarea__bottom" },
            [_vm._t("contentBottom")],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }